import { useEffect, useState } from "react"
import { validateQuantity } from "../../../../utils/validations";
import useDebounce from "../../../../hooks/useDebounce";

interface PlanRevisedQtyTableCellProps {
    site: any;
    handleSaveQty: (payload: object) => void;
    disabled: any
}


const PlanRevisedQtyTableCell: React.FC<PlanRevisedQtyTableCellProps> = ({ disabled, site, handleSaveQty }: any) => {
    const [quantity, setQuantity] = useState<string>("");
    const debouncedQuantity = useDebounce(quantity, 1000);
    const handleQuantityChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        if (validateQuantity(value, 'Kg')) {
            setQuantity(value);
        }
    }

    useEffect(() => {
        setQuantity(site?.revisedquantity == 0 ? String(site?.planquantity) : String(site?.revisedquantity));
    }, [site]);

    useEffect(() => {
        if ((String(site?.revisedquantity) !== debouncedQuantity && debouncedQuantity !== "" && String(site?.planquantity) !== debouncedQuantity)) {
            const payload = {
                sitecode: site?.sitecode,
                cafecode: site?.cafecode,
                cafename: site?.cafename,
                requestdishname: site?.requestdishname,
                requestdishcode: site?.requestdishcode,
                reviseddishcode: site?.reviseddishcode,
                reviseddishname: site?.reviseddishname,
                pax: site?.pax,
                planquantity: site?.planquantity,
                revisedpax: site?.revisedpax,
                revisedquantity: +debouncedQuantity
            }
            handleSaveQty(payload);
        }
    }, [debouncedQuantity]);

    return (
        <input type="text" value={quantity} onChange={(e) => handleQuantityChange(e)} placeholder="0.000" disabled={disabled} />
    )
}

export default PlanRevisedQtyTableCell